"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.marketFee = marketFee;

var _rxjs = require("rxjs");

var _util = require("@polkadot/api-derive/util");

// Copyright 2017-2022 @darwinia/api-derive authors & contributors
// SPDX-License-Identifier: Apache-2.0
function lastAssignedRelayerFee(api) {
  return api.query.pangolinParachainFeeMarket.assignedRelayers().pipe((0, _rxjs.map)(relayers => {
    const data = relayers.unwrapOr([]);

    if (data.length === 0) {
      return undefined;
    } // The market fee comes from the last item in AssignedRelayers from substrate runtime


    return {
      amount: data[data.length - 1].fee
    };
  }));
}
/**
 * @name marketFee
 * @description market fee
 * @example
 * <BR>
 *
 * ```javascript
 * api.derive.feeMarket.marketFee((fee) => {
 *   console.log(`the current market fee is ${fee}`);
 * });
 * ```
 */


function marketFee(instanceId, api) {
  return (0, _util.memo)(instanceId, () => {
    return lastAssignedRelayerFee(api);
  });
}